<template>
    <div>
        <section class="changepsw">
            <v-container>
                <v-row>
                    <v-col cols="14" offset="1" md="10" offset-md="3">
                        <h2 class="section-subtitle">Změna hesla</h2>
                        <v-card dark>
                            <form @submit.prevent="onChangePassword" ref="changePasswordForm">
                                <v-card-text>
                                    <v-text-field
                                        label="SOUČASNÉ HESLO"
                                        v-model.trim="oldPassword"
                                        type="password"
                                        :rules="rules.oldPassword"
                                        validate-on-blur
                                    ></v-text-field>
                                    <v-text-field
                                        label="NOVÉ HESLO"
                                        v-model.trim="newPassword"
                                        type="password"
                                        :rules="rules.newPassword"
                                        validate-on-blur
                                    ></v-text-field>
                                    <v-text-field
                                        label="NOVÉ HESLO ZNOVU"
                                        v-model.trim="newPasswordRepeat"
                                        type="password"
                                        :rules="rules.newPasswordRepeat"
                                        validate-on-blur
                                    ></v-text-field>
                                </v-card-text>
                                <v-divider></v-divider>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn type="submit" class="primary" :disabled="loading || !formIsValid" :loading="loading">
                                        Změnit heslo
                                    </v-btn>
                                </v-card-actions>
                            </form>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </section>
    </div>
</template>

<script>
    import { CHANGE_PASSWORD_REQUEST } from '../../store/actions/user'
    import { validator } from '../../plugins/validator'

    export default {
        name: 'ChangePassword',
        data () {
            return {
                oldPassword: '',
                newPassword: '',
                newPasswordRepeat: '',
                loading: false,
            };
        },
        computed: {
            comparePassword () {
                return this.newPassword === this.newPasswordRepeat || 'Hesla musí být stejná.';
            },
            rules () {
                return {
                    oldPassword: [validator.required],
                    newPassword: [validator.required, validator.password],
                    newPasswordRepeat: [validator.required, this.comparePassword],
                };
            },
            formIsValid () {
                return this.oldPassword !== ''
                    && this.newPassword !== ''
                    && this.comparePassword === true;
            },
        },
        methods: {
            async onChangePassword () {
                if (!this.formIsValid) {
                    return;
                }

                const data = {
                    oldPassword: this.oldPassword,
                    newPassword: this.newPassword,
                };

                try {
                    this.loading = true;
                    await this.$store.dispatch('user/' + CHANGE_PASSWORD_REQUEST, data);
                    this.$refs.changePasswordForm.reset();
                    this.$toast.success('Heslo bylo úspěšně změněno.');
                } catch (e) {
                    this.$toast.error('Při změně hesla došlo k chybě. Zkuste to později.');
                } finally {
                    this.loading = false;
                }
            },
        },
    }
</script>

